module.exports = __webpack_public_path__ + "static/media/overflow.df266b7e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/overflow.gif
// module id = 1532
// module chunks = 0